module.exports = __webpack_public_path__ + "static/media/stofferingen-49.80ddb67d.jpg";